module.exports = __webpack_public_path__ + "img/laboratorio_4-3_1536.b62fcf98.jpg";